import * as React from 'react';
import { createIllustration } from '@balance-web/illustration';

import { describeWithOptions } from './describeWithOptions';

export const CVCLogoName = 'CVCLogo';
export const CVCLogoDescription = 'Credit Card Verification Logo';

export const CVCLogo = createIllustration(
  describeWithOptions(CVCLogoName, CVCLogoDescription, 24, 16),
  <>
    <path
      clipRule="evenodd"
      d="M16.26 1.5H1.5C0.81 1.5 0 2.295 0 3V14.25C0 14.955 0.81 15.75 1.5 15.75H20.25C20.94 15.75 21.75 14.955 21.75 14.25V8.6025C21.1182 9.17085 20.3379 9.54799 19.5 9.69V9.75C19.5 10.245 19.23 10.5 18.75 10.5H2.25C1.77 10.5 1.5 10.245 1.5 9.75V9C1.5 8.505 1.77 8.25 2.25 8.25H15.3975C14.9646 7.77021 14.6404 7.20253 14.4473 6.58582C14.2541 5.96911 14.1965 5.31794 14.2784 4.67691C14.3604 4.03587 14.5798 3.42011 14.9218 2.87178C15.2639 2.32345 15.7203 1.85551 16.26 1.5V1.5Z"
      fill="#585C62"
      fillRule="evenodd"
      opacity="0.2"
    />
    <path
      clipRule="evenodd"
      d="M14.505 3.75H0V6H14.31C14.184 5.24556 14.2511 4.47151 14.505 3.75Z"
      fill="#585C62"
      fillRule="evenodd"
      opacity="0.3"
    />
    <path
      clipRule="evenodd"
      d="M18.75 10.5C17.3576 10.5 16.0223 9.94688 15.0377 8.96231C14.0531 7.97774 13.5 6.64239 13.5 5.25C13.5 3.85761 14.0531 2.52226 15.0377 1.53769C16.0223 0.553123 17.3576 0 18.75 0C20.1424 0 21.4777 0.553123 22.4623 1.53769C23.4469 2.52226 24 3.85761 24 5.25C24 6.64239 23.4469 7.97774 22.4623 8.96231C21.4777 9.94688 20.1424 10.5 18.75 10.5ZM16.665 3.075H16.0725L14.625 3.81V4.56L15.7725 3.96V7.425H16.6725V3.075H16.665ZM18.39 3.675C18.8175 3.675 19.1175 3.915 19.1175 4.26C19.1175 4.635 18.765 4.8975 18.255 4.8975H18.03V5.535H18.3C18.84 5.535 19.2075 5.805 19.2075 6.195C19.2075 6.57 18.8475 6.825 18.3375 6.825C17.9625 6.825 17.5875 6.705 17.1975 6.4725V7.2225C17.6175 7.4025 18.0375 7.5 18.45 7.5C19.4325 7.5 20.1075 6.9975 20.1075 6.27C20.1075 5.76 19.7925 5.3475 19.2675 5.1825C19.7175 5.0325 20.01 4.635 20.01 4.185C20.01 3.48 19.3875 3 18.4875 3C18.0818 3.0045 17.6812 3.09125 17.31 3.255V3.99C17.67 3.7875 18.0375 3.675 18.39 3.675ZM21.63 5.31C22.1775 5.31 22.56 5.6325 22.56 6.0525C22.56 6.495 22.1775 6.8025 21.63 6.8025C21.3 6.8025 20.955 6.6975 20.6025 6.48V7.2525C20.97 7.4175 21.345 7.5 21.7125 7.5C21.9075 7.5 22.0875 7.47 22.26 7.425C22.65 6.7875 22.875 6.0525 22.875 5.265L22.86 4.95C22.5811 4.78494 22.2614 4.70177 21.9375 4.71C21.8025 4.71 21.66 4.7175 21.51 4.74V3.765H22.59C22.4963 3.52494 22.3808 3.29397 22.245 3.075H20.73V5.4375C21.03 5.3625 21.33 5.31 21.63 5.31Z"
      fill="#20262D"
      fillRule="evenodd"
    />
  </>
);
